import { render, staticRenderFns } from "./SettingActionMenu.vue?vue&type=template&id=e730788a"
import script from "./SettingActionMenu.vue?vue&type=script&lang=ts"
export * from "./SettingActionMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports